export default "__VITE_ASSET__DiRAMqV5__"